<template>
  <!-- Content Wrapper. Contains page content -->

  <div>
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <br />

      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn"
      >
        Alterar Email
      </button>
      <form>
        <div class="form-group" :style="{color: corTexto}" >
          <label for="exampleInputEmail1">Novo email</label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Seu email"
            v-model="email"
          />
        </div>
        <div class="form-group" :style="{color: corTexto}" >
          <label for="exampleInputEmail1">Email atual</label>
          <label for="exampleInputEmail1" v-model="emailAtual">{{
            emailAtual
          }}</label>
        </div>
      </form>
      <div class="modal-footer">
        <button
          style="align-items: center; margin-top: 5px; margin-bottom: 5px;background-color:#006400 ;"
          class="btn btn-dark"
          @click="validateEmail(email)"
        >
          Alterar
        </button>
      </div>
    </div>
   
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
<script>
import Swal from "sweetalert2";
import Inis from "../services/inis";
import Usuario from "../services/usuario";
import { mapGetters } from "vuex"

export default {
  name: "AlterarEmail",
  data() {
    return {
      corFundo: "",
      corBotao: "",
      corTexto: "",
      email: "",
      emailAtual: localStorage.getItem("email" + localStorage.getItem('contrato')),
      usuarios: [],
      emailAux: "",
      logadoAux: "",
    };
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      logado: "retornaLogado",
    }),
  },
  methods: {
      listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then(resposta => {
        this.corTexto = resposta.data[0].vl;
      });      
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.email == "") {
        Swal.fire({
          title: "Preencha um email válido",
          confirmButtonColor: "#000000",
        });
      } else if (re.test(String(email).toLowerCase()) == false) {
        Swal.fire({
          title: "Preencha um email válido",
          confirmButtonColor: "#000000",
        });
      } else {
        Usuario.listandoEmail(this.email).then((resposta) => {
          
          if (resposta.data == null) {

            var u = new Object();
            u.email = this.email;
            u.cd = localStorage.getItem("cd" + localStorage.getItem('contrato'));

            Usuario.alterarusuario(u).then(function (response) {
              Swal.fire({
                title: "Email alterado",
                confirmButtonColor: "#000000",
              });
            });
            localStorage.setItem("email"+ localStorage.getItem('contrato'),this.email)
            this.$router.push("/");
          } else {
            Swal.fire({
              title: "Email já existente",
              confirmButtonColor: "#000000",
            });
          }
        });
      }
    },
    listandoUsuarios() {
      Usuario.listandoEmail(this.email).then((resposta) => {
        this.usuarios = resposta.data;
      });
    },
    verificaLogado() {
      if (this.logado == false) {
        this.$router.push("/login");
      }
    },
  },

  mounted() {
    this.listandoUsuarios();
    this.verificaLogado();
    this.listarinis();
  },
};
</script>